module.exports = require("@azure/core-amqp");